@if (shouldRender()) {
	<prism-menu *transloco="let t; prefix: 'shAgGrid.common.firmware'" placement="bottom-start">
		<div class="sh-container" slot="menu-trigger">
			<span id="sh-fw-version-value">{{ currentVersion() }}</span>
			@if (isLatestVersion() && showLatestIndicator()) {
				<span id="sh-fw-version-value-latest"> &nbsp;({{ t('latest') }})</span>
			}
			<span id="sh-fw-version-menu-selector" class="sh-fw-version-selector">
				<prism-icon icon="arrow_drop_down"></prism-icon>
			</span>
		</div>
		@for (package of availablePackages(); track package.version; let idx = $index) {
			<prism-menu-item [value]="package.version" [disabled]="!canUpdate()" (click)="onMenuSelection(package)">
				{{ package.version }}
				@if (showPackageKey()) {
					<span id="sh-fw-version-package-key"> &nbsp;({{ package.key }})</span>
				}
				@if (idx === 0 && showLatestIndicator()) {
					<span>({{ t('latest') }})</span>
				}
			</prism-menu-item>
		} @empty {
			<prism-menu-item disabled value="none">{{ t('no-updates-available') }}</prism-menu-item>
		}
	</prism-menu>
}
